import React, {useState, useEffect} from 'react'


const FallbackImage = (props) => {
  
  const [imgSrc, setImgSrc]  = useState(props.src)

  useEffect(() => {
      setImgSrc(props.src)
  }, [props.src])
  
  return (
   
    <img 
      {...props}
      src={imgSrc} 
      alt=""
      style={{objectFit:props?.objectFit||'cover'}}
      onError={() => {setImgSrc('https://res.cloudinary.com/dammymoses/image/upload/v1654672815/avatars/avatar_wv2acz.svg')}}
    />
   
  )
}

export default FallbackImage